import { useEffect, useRef } from 'react';

/**
 * Determine the mounted state of the component it is used in
 * @param isMountedDirectly Set to `true` if only the unmount matters and the component is considered mounted before during first render. Set to `false` if component should not be considered mounted until the next render.
 * @returns {boolean} whether the component is mounted or not
 */
export const useIsMounted = (isMountedDirectly = false) => {
    const isMounted = useRef(isMountedDirectly);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted.current;
};
